import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
import { Router,ActivatedRoute} from  '@angular/router';
import { AuthenticationService } from './../../service/auth/auth.service';
import { HttpClient  } from '@angular/common/http';
import { MustMatch } from './../../must-match.validator';
import { ToastrService } from 'ngx-toastr';
import { environment } from './../../../environments/environment';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  passwordForm: FormGroup;
  isSubmitted :boolean=  false;
  isValid:boolean=  false;
  loader:boolean=false;
  public id:string;
  public type:string;
  private sub: any;
  private API_URL= environment.API_URL;
  constructor(
    private router: Router,
    public formBuilder: FormBuilder,
    private service:AuthenticationService,
    private http:HttpClient,
    private route: ActivatedRoute,
    private toastr:ToastrService,
  ) { 
    this.sub = this.route.queryParams.subscribe(params => {
      this.id = params['id'];
      this.type = params['type'];
      //console.log( this.id);


    });

  }

  ngOnInit() {
   
     this.passwordForm  =  this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      password_confirmation:['', [Validators.required]],
    },
      {
        validator: MustMatch('password', 'password_confirmation')
    });

     this.http.post(this.API_URL+'/admin/resetPasswordValid',{'id':this.id}).subscribe((res:any)=>{
      if(res.status===false){
        this.router.navigate(["/"]);
      }
     },
     (err) => {
      if(err.status==401){
       this.toastr.error(err.error.message);
      }else if(err.status==403){
       this.toastr.error(err.error.message)
       this.router.navigate(["home"]);
      }
      else if(err.status==422){
       for (let key in err.error.message) {
         this.toastr.error(err.error.message[key]);
       }
      }
     });


 }
  get formControls() { return this.passwordForm.controls; }
ChangePassword(){
  this.loader=true;
  this.isSubmitted = true;
  this.isValid=true;
  // console.log(this.passwordForm.valid);
  if (this.passwordForm.valid) {
      let data=this.passwordForm.value;
      data.token=this.id;
      data.type=this.type;

   this.updatePassword(this.passwordForm.value);



  } else {
    this.isSubmitted = false;
  
  }

}
updatePassword(data: any) {
  this.service.changePassword(data).subscribe((res:any)=>{
    this.loader = false;
    if (res.status == true) {
      if(res.data.role_id == '1' || res.data.role_id == '2'){
        this.router.navigate(['wgiacm']);
      }else{
        this.router.navigate(['login']);
      }
      this.toastr.success(res.message);
    } else {
      this.toastr.success(res.message);
      this.isSubmitted = false;
      this.loader=false;
    }
  });
}

}
